import { create } from 'zustand';

type TpeStatus = 'disconnected' | 'connected' | 'busy' | 'error';
type PrinterStatus = 'disconnected' | 'connected' | 'error';
type TpePaperStatus = 'OK' | 'LOW' | 'EMPTY' | 'unknown';

interface HardwareState {
  tpeStatus: TpeStatus;
  tpeError: string | null;
  tpePaperStatus: TpePaperStatus;
  printerStatus: PrinterStatus;
  printerError: string | null;

  setTpeStatus: (status: TpeStatus, error?: string) => void;
  setTpePaperStatus: (status: TpePaperStatus) => void;
  setPrinterStatus: (status: PrinterStatus, error?: string) => void;
  resetAll: () => void;
}

const DEFAULTS = {
  tpeStatus: 'disconnected' as TpeStatus,
  tpeError: null as string | null,
  tpePaperStatus: 'unknown' as TpePaperStatus,
  printerStatus: 'disconnected' as PrinterStatus,
  printerError: null as string | null,
};

export const useHardwareStore = create<HardwareState>()((set) => ({
  ...DEFAULTS,

  setTpeStatus: (status, error) =>
    set({
      tpeStatus: status,
      tpeError: error ?? null,
    }),

  setTpePaperStatus: (status) =>
    set({ tpePaperStatus: status }),

  setPrinterStatus: (status, error) =>
    set({
      printerStatus: status,
      printerError: error ?? null,
    }),

  resetAll: () => set(DEFAULTS),
}));
